<template>
  <vi-page>
    <div>{{ text }}</div>
    <a class="hidden" ref="rA" :href="url" target="_blank">{{ url }}</a>
  </vi-page>
</template>
<script>
export default {
  name: "Jump",
  data() {
    return {
      text: "正在获取跳转链接...",
      url: "#",
    };
  },
  mounted() {
    this.eJump();
  },
  methods: {
    eGetUrl() {
      return new Promise((resolve, reject) => {
        this.$$.api
          .post("/shiyun/aliyun/apis/biz/ramuser/samlsp/login")
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    eJump() {
      this.eGetUrl()
        .then((res) => {
          this.text = "正在跳转...";
          this.url = res.data.loginUrl;
          setTimeout(() => {
            this.$refs.rA.click();
          }, 1000);
        })
        .catch((err) => {
          this.$$.toastr.error(err.message);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.hidden {
  display: none;
}
</style>
